import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IFrostMeasurementStation } from '../../interfaces/IFrostMeasurementStation';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FrostmeasurementService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  private usersettingsUrl=environment.serverUrl+'FrostMeasurements' ;  // URL to web api  // URL to web api
 
  constructor(private http: HttpClient) { }

  
  public get = (route: string) => {
    return this.http.get(this.createCompleteRoute(route, this.usersettingsUrl));
  }

  public getStations=(route: string):Observable<IFrostMeasurementStation[]>  => {   
    return this.http.get<IFrostMeasurementStation[]>(this.createCompleteRoute(route, this.usersettingsUrl));    
  }
  private createCompleteRoute = (route: string, envAddress: string) => {
    return `${envAddress}/${route}`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }
}
